<template>
  <div class="tabs-content-content tabs-content-buttons">
    <type
      :key="type.name"
      :icon="type.icon"
      :title="type.name"
      v-for="type in types"
    />
  </div>
</template>

<script>
import Type from './Type'
import Const from '../../const/component'

export default {
  name: 'Elements',
  components: {
    Type,
  },
  data: () => ({
    types: [
      {
        icon: 'boxes',
        name: Const.TEXT_WITH_BUTTONS,
      }, 
      {
        icon: 'comment-dots',
        name: Const.QUICK_REPLY,
      }, 
      {
        icon: 'adjust',
        name: Const.GENERIC_TEMPLATE,
      }, 
      {
        icon: 'paper-plane',
        name: Const.BUTTON,
      },
    ]
  }),
}
</script>